import columns from '../../react-table/helpers/columns';
import TableDefinitions from '../../../common/TableDefinitions';

export function getEditPage(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/weekly-thresholds-edit',
    tableId: TableDefinitions.YEARLY_THRESHOLDS_PAGE.id,
    text: 'Edit Min/Max',
  } : {};
}

export default (data, userType) => {
  const {
    FilteredDateTimeColumn,
    FilteredNumberColumn,
    EditButtonColumn,
    NavigationColumn,
    FilteredTextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredNumberColumn('Week number', 'weekNo'),
        new FilteredNumberColumn('Min', 'minThreshold'),
        new FilteredNumberColumn('Max', 'maxThreshold'),
        new FilteredDateTimeColumn('Last modified', 'lastUpdateDate'),
        new NavigationColumn(new EditButtonColumn('Edit action', '', '', 'Edit Min/Max').withShow(userType.includes('IPC')), getEditPage),
      ],
      columnsOnDownload: [
        new FilteredTextColumn('Operator Code', 'operatorCode'),
        new FilteredTextColumn('IMPC Code', 'impcCode'),
      ],
    },
  ];
};
